import { Box, Link, Typography } from "@material-ui/core";
import { Trans, useTranslation } from "react-i18next";

import { NotificationEvent } from "@dashboard-v3/api";
import DatasetSyncFailureDetails from "./DatasetSyncFailureDetails";

/**
 * Detalle de una notificacion de plataforma, elegido por `code`.
 *
 * Antes de MXH-5844 no habia eleccion: se mostraba el aviso de sincronizacion de
 * accounts and groups para CUALQUIER notificacion PLATFORM. Ese sigue siendo el
 * caso por defecto para no cambiarle el render a los codigos que ya existian.
 */
export default function PlatformDetails({
  notification,
}: {
  notification: NotificationEvent;
}) {
  if (notification.code === "dataset-sync-failure") {
    return <DatasetSyncFailureDetails notification={notification} />;
  }

  return <AccountsAndGroupsSyncWarning />;
}

function AccountsAndGroupsSyncWarning() {
  const { t } = useTranslation("notifications");

  return (
    <Box style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <Typography component="span">{t("warnings.sync.title")}</Typography>
      <Typography variant="body2" color="textSecondary">
        <Trans i18nKey="notifications:warnings.sync.description">
          <Link href="/accounts" target="_blank"></Link>
          <b></b>
        </Trans>
      </Typography>
    </Box>
  );
}
